const GROUP_TYPE_DISPLAY_NAMES = {
  Inform: "Dynamic Data",
};

/**
 * Returns a human-readable label for a group type value.
 * Maps internal type names to user-friendly display names where they differ.
 */
export function groupTypeLabel(groupType) {
  if (!groupType) return "Unknown";
  return GROUP_TYPE_DISPLAY_NAMES[groupType] || groupType;
}
